import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";

import ProtectedLayout from "../pages/protected/component";
import isAuthenticated from "../utils/isAuthenticated";

export const Route = createFileRoute("/__auth")({
  beforeLoad: () => {
    if (!isAuthenticated()) {
      throw redirect({ to: "/login" });
    }
  },
  component: () => (
    <ProtectedLayout>
      <Outlet />
    </ProtectedLayout>
  ),
});
